<template>
  <div class="flex gap-1 items-center">
    <button
      class="btn btn-ghost btn-xs flex items-center gap-1"
      @click="router.push(`/crystal#1`)"
    >
      <CrystalIcon />
      {{ fixNumber(userStore.user.crystalQuantity) }}
    </button>
    <button
      class="btn btn-ghost btn-xs flex items-center gap-1"
      @click="router.push(`/crystal#2`)"
    >
      <PowerIcon />
      {{ fixNumber(userStore.user.powerAmount) }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import { fixNumber } from "@/components/Mission/MissionStat";
import { useGlobalUser } from "@/stores/globalUser";
import { useRouter } from "vue-router";

const userStore = useGlobalUser();
const router = useRouter();
</script>
